import {
  Form, SectionDivider, SidebarModalListItem,
} from '@domain-group/suit-theme'

import StatusBadge from '@components/StatusBadge'

import ScopedConditionalContent from '@components/ScopedConditionalContent'
import type { useCreateOrEditOrderItemTaskModalPayload } from '../../hooks/useCreateOrEditOrderItemTaskModal'

interface TaskDetailsProps {
  hookPayload: useCreateOrEditOrderItemTaskModalPayload,
}

const TaskDetails = (props: TaskDetailsProps) => {
  const { hookPayload } = props
  const {
    agency,
    campaign,
    order,
    urls: {
      editCampaignUrl,
      editProviderAccountUrl,
      editOrderUrl,
    },
    status,
  } = hookPayload

  return (
    <>
      <SectionDivider boxProps={{ marginTop: 'large' }}>TASK DETAILS</SectionDivider>

      <Form.Field label="Status">
        {/*
         // @ts-expect-error TS2339 */}
        <StatusBadge statusId={status.id} />
      </Form.Field>

      <ScopedConditionalContent
        permittedRoleTitles={['Provider Employee', 'Provider Director', 'Provider Employee']}
      >
        {campaign?.id && (
          <Form.Field label="Campaign" marginTop="large">
            <SidebarModalListItem
              boxProps={{ padding: 0 }}
              secondaryText={`# ${campaign.id}`}
              title={campaign?.title}
            >
              {/*
               // @ts-expect-error TS2339 */}
              <SidebarModalListItem.Actions>
                {/*
                 // @ts-expect-error TS2339 */}
                <SidebarModalListItem.Icon href={editCampaignUrl} type="link" />
                {/*
               // @ts-expect-error TS2339 */}
              </SidebarModalListItem.Actions>
            </SidebarModalListItem>
          </Form.Field>
        )}

        {agency?.id && (
          <Form.Field label="Agency" marginTop="large">
            <SidebarModalListItem boxProps={{ padding: 0 }} title={agency?.title}>
              {/*
               // @ts-expect-error TS2339 */}
              <SidebarModalListItem.Actions>
                {/*
                 // @ts-expect-error TS2339 */}
                <SidebarModalListItem.Icon href={editProviderAccountUrl} type="link" />
                {/*
               // @ts-expect-error TS2339 */}
              </SidebarModalListItem.Actions>
            </SidebarModalListItem>
          </Form.Field>
        )}

        {order?.id && (
          <Form.Field label="Order" marginTop="large">
            <SidebarModalListItem boxProps={{ padding: 0 }} title={order?.title}>
              {/*
               // @ts-expect-error TS2339 */}
              <SidebarModalListItem.Actions>
                {/*
                 // @ts-expect-error TS2339 */}
                <SidebarModalListItem.Icon href={editOrderUrl} type="link" />
                {/*
               // @ts-expect-error TS2339 */}
              </SidebarModalListItem.Actions>
            </SidebarModalListItem>
          </Form.Field>
        )}
      </ScopedConditionalContent>
    </>
  )
}

export default TaskDetails
